import { Button, Grid, Typography } from '@mui/material';
import * as React from 'react';
import FormLogin from './FormLogin';
import FormRegister from './FormRegister';

export default function LoginRegisterContainer() {
    const [isFormLogin, setIsFormLogin] = React.useState<boolean>(false);

    const handleClick = () => {
        setIsFormLogin(!isFormLogin);
    };

    return (
        <Grid
            container
            item
            direction="column"
            wrap="nowrap"
            alignItems="center"
            justifyContent="center"
            spacing={2}
        >
            <Grid item width="100%">
                {isFormLogin && <FormLogin />}
                {!isFormLogin && <FormRegister />}
            </Grid>
            <Grid container item alignItems="center" flexDirection="row" justifyContent="center">
                <Grid item>
                    <Typography>
                        {isFormLogin ? 'Not registered yet?' : 'Already have an account?'}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button variant="text" onClick={handleClick}>
                        {isFormLogin ? `Create an Account` : 'Log In'}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
